import { getStaffDisplayName } from './staff';

// Muted, professional background tones for initials avatars.
const AVATAR_BACKGROUNDS = ['#e2e8f0', '#e5e7eb', '#dbe4ee', '#e7e5e4', '#dde7e3'];

function seedIndex(seed, max) {
  const str = String(seed || 'user');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash % max;
}

function initialsFromSeed(seed) {
  const str = String(seed || '').trim();
  if (!str) return '?';
  const parts = str.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
  }
  const one = parts[0] || str;
  if (one.includes('@')) {
    return (one.split('@')[0].slice(0, 2) || '?').toUpperCase();
  }
  return one.slice(0, 2).toUpperCase();
}

export function avatarUrl(seed, size = 128, displayName = '') {
  const bg = AVATAR_BACKGROUNDS[seedIndex(seed, AVATAR_BACKGROUNDS.length)];
  const fg = '#475569';
  const label = initialsFromSeed(displayName || seed);
  const fontSize = Math.round(size * 0.36);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 128 128"><circle cx="64" cy="64" r="64" fill="${bg}"/><text x="64" y="64" text-anchor="middle" dominant-baseline="central" font-family="system-ui,Segoe UI,sans-serif" font-size="${fontSize}" font-weight="600" fill="${fg}">${label}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function staffAvatar(staff, size = 128) {
  const explicitSeed = staff?.avatarSeed || staff?.profileSelectedSeed;
  const fallbackSeed = staff?.email || staff?.name || staff?.id || 'staff';
  const seed = explicitSeed || fallbackSeed;
  const useGenerated = staff?.avatarUseGenerated === true || !staff?.photoUrl;
  if (useGenerated) return avatarUrl(seed, size, getStaffDisplayName(staff) || staff?.email || '');
  return staff.photoUrl;
}

export const AVATAR_VARIANTS = [
  'adventurer'
];
